import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { addReqiredMessage } from '@/components/slides/DataSummary/util/addRequiredMessage.ts';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useForm } from '@/form/useForm.ts';

export const AddressSummaryFormPL = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({ slideIds: ['address'] });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  const streetField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'street'),
    message: s.dataSummary.requiredMessage!,
  });
  const streetLabel = translate(streetField?.label);

  const housenoField = s.address.fields.find(({ name }) => name === 'houseno');
  const housenoLabel = translate(housenoField?.label);

  const apartmentField = s.address.fields.find(({ name }) => name === 'apartment');
  const apartmentLabel = translate(apartmentField?.label);

  const zipcodeField = s.address.fields.find(({ name }) => name === 'zipcode');
  const zipcodeLabel = translate(zipcodeField?.label);

  const cityField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'city'),
    message: s.dataSummary.requiredMessage!,
  });
  const cityLabel = translate(cityField?.label);

  return (
    <div className="summary-card" data-cy={'summary-form-address'}>
      <h2>{translate(s.dataSummary.titles?.address)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{streetLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('street')}
          {editMode && <EditDataField field={streetField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{housenoLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('houseno')}
          {editMode && <EditDataField field={housenoField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{apartmentLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('apartment')}
          {editMode && <EditDataField field={apartmentField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{zipcodeLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('zipcode')}
          {editMode && <EditDataField field={zipcodeField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{cityLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('city')}
          {editMode && <EditDataField field={cityField!} slideId={'address'} />}
        </div>
      </div>
    </div>
  );
};
